var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDeletePb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 5a5 5 0 0 1 5-5h9a6 6 0 0 1 6 6v8a1 1 0 1 1-2 0V6a4 4 0 0 0-4-4H7a3 3 0 0 0-3 3 1 1 0 0 1-2 0m1 11a1 1 0 0 1 1 1 3 3 0 0 0 3 3h8.13a1 1 0 1 1 0 2H7a5 5 0 0 1-5-5 1 1 0 0 1 1-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.918 7a1 1 0 1 0 1.998.002A1 1 0 0 0 10.918 7m-2 0a3 3 0 1 0 6 0 3 3 0 1 0-6 0",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.918 13a3 3 0 0 0-2.836 2.018c-.18.522-.612.982-1.165.982-.552 0-1.01-.452-.9-.994a5.002 5.002 0 0 1 9.802 0c.109.542-.35.994-.901.994-.553 0-.984-.46-1.165-.982A3 3 0 0 0 11.918 13"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.707 17.707a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 1 1-1.415 1.415l-2.828-2.829a1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.707 21.95a1 1 0 0 1 0-1.415l2.828-2.828a1 1 0 0 1 1.415 1.414L20.12 21.95a1 1 0 0 1-1.414 0M1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H2a1 1 0 0 1-1-1M1 13a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})));
export default SvgIcDeletePb;